import { AdditionalHeader } from './core/baseRequest';
import { TokenRequest } from './tokenRequest';
import { objectToUrlEncodedString } from './core/formEncodedDataHelper';

export class RefreshTokenRequest extends TokenRequest {
    constructor(username: string, public refreshToken: string) {
        super(username);
    }

    protected buildRequestInit(additionalHeaders: AdditionalHeader[]): RequestInit {
        return {
            ...super.buildRequestInit(additionalHeaders),
            method: 'POST',
            body: objectToUrlEncodedString({
                grant_type: 'refresh_token',
                username: this.username,
                refresh_token: this.refreshToken,
                client_id: this.clientId
            })
        };
    }
}
